import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, FormLabel, Stack, Card, CardHeader, CardContent, CardActions, IconButton, Grid, } from '@mui/material';
import { AccordionExpandIcon } from '../atoms/Icons';
import { HelpWithDialogIcon } from './HelpWithDialogIcon';
import { ScrollDialog } from '../dialog/ScrollDialog';
import OrderedItemDetail from './OrderedItemDetail';
var OfferedItemsCard = function (_a) {
    var orderedItem = _a.orderedItem, isOrderColumnShown = _a.isOrderColumnShown, isSampleOrderColumnShown = _a.isSampleOrderColumnShown, renderFarmWithLink = _a.renderFarmWithLink, renderStock = _a.renderStock, renderComment = _a.renderComment, renderOrderTypeIcon = _a.renderOrderTypeIcon, renderFobPrice = _a.renderFobPrice, renderSampleOrder = _a.renderSampleOrder, renderOrderAmount = _a.renderOrderAmount, _b = _a.isUSRoaster, isUSRoaster = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var _c = React.useState(false), confirmDialogOpen = _c[0], setConfirmDialogOpen = _c[1];
    var handleClickHelp = function () {
        setConfirmDialogOpen(true);
    };
    var canDisplayOrderText = React.useCallback(function (orderedItem) {
        return (orderedItem.offer.orderType === 'basic' &&
            orderedItem.remainingQuantity > 0) ||
            (orderedItem.offer.orderType === 'auction' &&
                !orderedItem.offer.bidSubmitted);
    }, []);
    return (React.createElement(Card, { key: orderedItem.id, sx: { boxShadow: function (theme) { return theme.customShadows.card; } } },
        React.createElement(CardHeader, { avatar: orderedItem.offer.orderType !== 'basic' && (React.createElement(Box, null, renderOrderTypeIcon(orderedItem))), action: React.createElement(IconButton, { onClick: handleClickHelp },
                React.createElement(AccordionExpandIcon, null)), title: orderedItem.offer.lotNumber, sx: {
                backgroundColor: function (theme) { return theme.customPalette.background.neutral; },
                padding: '12px 16px',
                fontWeight: 600,
            } }),
        React.createElement(ScrollDialog, { open: confirmDialogOpen, onClose: function () { return setConfirmDialogOpen(false); }, title: orderedItem.offer.lotNumber },
            React.createElement(OrderedItemDetail, { orderedItem: orderedItem })),
        React.createElement(CardContent, { sx: {
                padding: '12px 16px',
            } },
            React.createElement(Stack, { spacing: 1.5 },
                React.createElement(Stack, { direction: "column" },
                    React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.body3; } } }, t('params.offer.farm')),
                    React.createElement(Box, { sx: {
                            typography: function (theme) { return theme.customTypography.body2; },
                            fontWeight: 600,
                        } }, renderFarmWithLink(orderedItem))),
                React.createElement(Stack, { direction: "column" },
                    React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.body3; } } }, t('params.offer.variety')),
                    React.createElement(Box, { sx: {
                            typography: function (theme) { return theme.customTypography.body2; },
                            fontWeight: 500,
                        } }, orderedItem.offer.variety)),
                React.createElement(Stack, { direction: "column" },
                    React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.body3; } } }, t('params.offer.processing')),
                    React.createElement(Box, { sx: {
                            typography: function (theme) { return theme.customTypography.body2; },
                            fontWeight: 500,
                        } }, orderedItem.offer.processing)),
                React.createElement(Stack, { direction: "column" },
                    React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.body3; } } }, t('labels.stock')),
                    React.createElement(Box, { sx: {
                            typography: function (theme) { return theme.customTypography.body2; },
                            fontWeight: 500,
                        } }, renderStock(orderedItem))),
                React.createElement(Stack, { direction: "column" },
                    React.createElement(Box, { sx: {
                            display: 'flex',
                            typography: function (theme) { return theme.customTypography.body3; },
                        } },
                        t("params.offer.".concat(isUSRoaster ? 'fobPriceUsdPerLb' : 'fobPrice')),
                        React.createElement(HelpWithDialogIcon, { title: t('pages.offerList.FreeOnBoardHelp.title'), description: t('pages.offerList.FreeOnBoardHelp.body') })),
                    React.createElement(Box, { sx: {
                            typography: function (theme) { return theme.customTypography.body2; },
                            fontWeight: 500,
                        } }, renderFobPrice(orderedItem))))),
        React.createElement(CardActions, { sx: {
                padding: '12px 0',
                backgroundColor: function (theme) { return theme.customPalette.background.neutral; },
            } },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 4, sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } }, isSampleOrderColumnShown ? (React.createElement(Stack, { spacing: 1, direction: "column", alignItems: "center" },
                    t('pages.roasterOrder.sampleOrder'),
                    React.createElement(FormLabel, null, renderSampleOrder(orderedItem)))) : ('-')),
                React.createElement(Grid, { item: true, xs: 4, sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } }, isOrderColumnShown ? (React.createElement(Stack, { spacing: 1, direction: "column", alignItems: "center" },
                    canDisplayOrderText(orderedItem) && (React.createElement(Box, null, t('pages.roasterOrder.orderAmount'))),
                    renderOrderAmount(orderedItem))) : ('-')),
                React.createElement(Grid, { item: true, xs: 4, sx: {
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                    } }, renderComment(orderedItem))))));
};
export default React.memo(OfferedItemsCard);
